import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountries } from "../actions/countryActions";
import { CountryList } from "../modal/contactModal";

const PreferredCountry = React.memo((props) => {
  const dispatch = useDispatch();

  const countryList = useSelector((state) => state.countryList);
  const { countries, loading, error } = countryList;
  const [checkk, setCheckk] = useState([]);
  const handleChange = (e) => {
    let { value, checked } = e.target;
    let tempcheck = checkk;
    if (checked) {
      tempcheck.push({ name: value });
    } else {
      tempcheck = tempcheck.filter((ck) => ck.name !== value);
    }

    let str = "";
    for (var i = 0; i < tempcheck.length; i++) {
      str += tempcheck[i].name + ",";
    }
    str = str.replace(/,\s*$/, "");
    setCheckk(tempcheck);
    props.handleAchange(str);
  };

  useEffect(() => {
    if (!countries) {
      dispatch(getCountries());
    }
  }, [countries]);

  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          {CountryList ? (
            CountryList.map((countri, i) => (
              <div key={countri.Id} className="form-check">
                <label className="form-check-label" for={countri.Id}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value={countri.I_Country}
                    onChange={(e) => handleChange(e)}
                  />
                  {countri.I_Country}
                </label>
              </div>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
          )}
        </>
      )}
    </>
  );
});

export default PreferredCountry;
